import Enum from './Enum.js';

export default class ScoreType extends Enum {
  static AVERAGE = new ScoreType('AVERAGE', '達成率');
  static TOTAL = new ScoreType('TOTAL', '合計点');
}
